import {get, post} from "./request";
import axios from "axios";

export const importExcel = (formdata) => {
    return post('tools/import', formdata)
}
export const categoryList = (params) => {
    return get('admin/resourceClassList', params)
}
export const courseList = (params) => {
    return get('admin/courseLists', params)
}

export const uploadFileApi = (form) => {
    return axios.post("file/upload", form, {
        headers: {
            "content-type": "multipart/form-data"
        }
    })
}

export const uploadPdf = (formData, onUploadProgress) => {
    return post("file/upload_file", formData, {
        onUploadProgress,
    })
}

export const recordLessons = (params) => {
    if (localStorage.getItem('role') == 3) return post('admin/courseProgress', params);
    if (localStorage.getItem('role') == 4) return post('jd/learnProgress', params)
}

export const quitLessons = (params) => {
    return post('jd/stuSignEnd', params);
}

export const allMaterials = (params) => {
    return get('courseware/showCourseWares', params);
}

export const showTeacherCourseList = () => {
    return get("admin/showTeaCourse");
}

export const downloadTmpl = (params = {}) => {
    return get("exam/topictemplate", params);
}

export const getCategoryList = (parmas = {}) => {
    return get("admin/resourceClassList", parmas);
}
export const getCagetoryTopicCount = (params) => {
    return get("paper/topic_count", params)
}

export const buildRandomPaper = (data) => {
    return post("paper/build", data)
}
export const randomPaperInfo = (id) => {
    return get("paper/info", {id: id})
}
export const setCoursePaperShow = (data) => {
    return post("exercise/paper/set", data);
}
export const cleanStuData = (data) => {
    return post("exercise/paper/clean", data);
}
export const submitPaperData = (data) => {
    return post("exercise/paper/submit", data);
}

export const examPaperInfo = (params) => {
    return get("exam/class/paper", params);
}

export const submitExerciseClass = (data) => {
    return post("exercise/class/submit", data)
}

export const markListData = (params) => {
    return get("/mark/list", params);
}

export const markScore = (data) => {
    return post("mark/set", data);
}

export const markDetail = (params) => {
    return get("mark/detail", params);
}